import { EntityController } from "./EntityController";
import { TulipAssetConstant } from "../TulipAssetConstants";
import { COCOS_PLAN_MODULE_PATH } from "../../constants";
import { PlanManager } from "../../cocosPlan";
import { Commands, ComponentConstants, Wall, WallType } from "@rhinov/savane-js";
import { ARRMGR_CLOUDINARY_ALLOWED, ARRMGR_CLOUDINARY_URL, getFrontUrl, getMediaUrl } from "@rhinov/asset-manager-service";



export class WallEntityController extends EntityController {

    allModelsForCurrentDecoratedWall: Array<any>;
    declare entity: Wall;

    constructor(entity: Wall, panel: any, deliverable: any, openAssetDetailCallback: CallableFunction) {
        super(entity, panel, deliverable, openAssetDetailCallback);
        this.allModelsForCurrentDecoratedWall = TulipAssetConstant.getinstance().getModelList(this.entity);
        this.updatepreviewWall();
    }

    updateslopeToggle(prop: any) {

        var element = document.getElementById('buttonToggle-' + prop.key) as HTMLInputElement;
        //Value is a boolean displayed using a toggle button
        if (element) {
            element.checked = (this.entity as any)[prop.key];
        }

        // Display slope start height with an edit text
        var height = document.getElementById('boxHeight-' + prop.key) as HTMLInputElement;
        var length1 = document.getElementById('boxLength1-' + prop.key) as HTMLInputElement;
        var length2 = document.getElementById('boxLength2-' + prop.key) as HTMLInputElement;
        if (!height || !length1 || !length2) return;
        this.lockCappedPlusLess(prop.key, 'Height', this.entity.addToCappedProperty(prop.key + 'Height', 0));
        height.value = ((this.entity as any)[prop.key + 'Height']) / 10 + '';

        // Display slope length for direct direction with an edit text
        this.lockCappedPlusLess(prop.key, 'Length1', this.entity.addToCappedProperty(prop.key + 'Length1', 0));
        length1.value = ((this.entity as any)[prop.key + 'Length1']) / 10 + '';

        // Display slope length for undirect direction with an edit text
        this.lockCappedPlusLess(prop.key, 'Length2', this.entity.addToCappedProperty(prop.key + 'Length2', 0));
        length2.value = ((this.entity as any)[prop.key + 'Length2']) / 10 + '';


        height = document.getElementById(prop.key + 'Height') as HTMLInputElement;
        length1 = document.getElementById(prop.key + 'Length1') as HTMLInputElement;
        length2 = document.getElementById(prop.key + 'Length2') as HTMLInputElement;

        if (!height || !length1 || !length2) return;
        // Hide or unhide element depending on slope boolean true/false and allow/forbid spacial wall toggle
        if (!(this.entity as any)[prop.key]) {
            // Hide all other sub-properties (height and both lengths)
            height.classList.add('hide');
            length1.classList.add('hide');
            length2.classList.add('hide');
            // Enable special wall to be toggled
            var special = document.getElementById('buttonToggle-isSpecialWall') as HTMLInputElement;
            if (special) {
                special.disabled = false;
            }
        }
        else {
            // Unhide all other sub properties (height and both lengths)
            height.classList.remove('hide');
            length1.classList.remove('hide');
            length2.classList.remove('hide');
            // Disable special walls from being toggled
            var special = document.getElementById('buttonToggle-isSpecialWall') as HTMLInputElement;
            if (special) {
                special.disabled = true;
            }
        }
    }

    openEntityDetail() {
       
        var path = 'decorated-walls/';
        var comp = this.entity.getComponent(ComponentConstants.ComponentType.WallType) as WallType;
        var id = comp.wallTypeId;

        if (this.openAssetDetailCallback) {
            this.openAssetDetailCallback(getFrontUrl() + path + id);
            return;
        }
        window.open(getFrontUrl() + path + id);
    };

    openAssetDetail(res: any) {
        
        var path = "decorated-walls/";
        if (this.openAssetDetailCallback) {
            this.openAssetDetailCallback(getFrontUrl() + path + res._id);
            return;
        }
        window.open(getFrontUrl() + path + res._id);
    };

    isWallModelSelected(modele: any): boolean {
        var obj = this.entity;
        var component = obj.getComponent(ComponentConstants.ComponentType.WallType) as WallType;

        if (component !== null) {
            if (component.wallTypeId === modele._id) {
                return (true);
            }
        }

        return (false);
    };


    updateWallModeleType(modele: any) {
        var obj = this.entity;
        var component = obj.getComponent(ComponentConstants.ComponentType.WallType);

        if (component !== null) {
            PlanManager.getInstance().executeCommand(new Commands.EditComponentCommand(component, modele._id));
        }
        else {
            PlanManager.getInstance().executeCommand(new Commands.AddComponentCommand(new WallType(modele._id), obj, true, false));
        }
        this.itemPreview = this.getWallPreviewUrl(modele);
    };

    updateselectWallModel() {
        var wall = document.getElementById('wallContainer');
        if (!wall) return;
        if (!this.entity.isSpecialWall && !this.entity.isTechnicalElementEntity()) {
            wall.classList.add('hide');
        }
        else {
            wall.classList.remove('hide');
            let listWall = document.getElementById('wallList');
            let list = document.getElementById('propertiesList');
            if (list && listWall) {
                listWall.style.maxHeight = list.getBoundingClientRect().height * 0.9 + 'px'; 
            }
        }
    }

    updatepreviewWall() {
        let image = document.getElementById('previewWall');
        if (!this.entity.isSpecialWall && !this.entity.isTechnicalElementEntity()) {
            if (image) {
                image.classList.add('hide');
            }
        } else {
            if (image) {
                image.classList.remove('hide');
            }

            var component = this.entity.getComponent(ComponentConstants.ComponentType.WallType) as WallType;
            if (component !== null) {
                this.itemPreview = getMediaUrl() + 'decoratedWalls/' + component.wallTypeId + '/medias/previews/preview1-sm.webp';
                if (ARRMGR_CLOUDINARY_ALLOWED) {
                    this.itemPreview = ARRMGR_CLOUDINARY_URL + component.wallTypeId + '/medias/previews/preview1-sm.webp';
                }
            }
            
            if (image && image.getElementsByTagName("img")[0]) {
                image.getElementsByTagName("img")[0].src = this.itemPreview ?? '';
            }
        }
    }

    override updatebuttonToggle(prop: any) {
        super.updatebuttonToggle(prop);

        if (prop.key === 'isSpecialWall') {
            var element = document.getElementById('buttonToggle-slope') as HTMLInputElement;
            if (!element) return;
            if ((this.entity as any)[prop.key]) {
                // Disable wall slopes from being toggled
                element.disabled = true;
            }
            else {
                // Enable wall slopes to  be toggled
                element.disabled = false;
            }
        }
    }

    getWallPreviewUrl(modele: any): string {
        if (modele !== null) {
            var url = getMediaUrl() +
                'decoratedWalls/' +
                modele._id +
                '/medias/previews/preview1-sm.webp';

            if (ARRMGR_CLOUDINARY_ALLOWED) {
                url = ARRMGR_CLOUDINARY_URL + modele._id + '/medias/previews/preview1-sm.webp';
            }
            return (url);
        }
        else {
            return (COCOS_PLAN_MODULE_PATH + "cocos/resources/loading.gif");
        }
    };

}